import React from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { Fields } from '../components'

const FormPartThree = props => {
  const { formIndex, formError, changeTabs, storeFormData, formData, isPromoForm = false } = props

  const validationSchema = yup
    .object({
      licenseState: yup.object().required('Please select your license issuing state'),
      licenseNumber: yup.string().required('Please enter your license number'),
      licenseExpiration: yup
        .string()
        .matches(/^(\d{2}\/\d{2}\/\d{4})$/, 'Please enter a valid expiry date')
        .required('Please enter your license expiry'),
      // creditCardType: yup
      //   .object().required('Please select your card type'),
      // creditCardNumber: yup
      //   .string().length(16, 'Please enter your card number')
      //   .matches(/^\d*$/, 'Please enter a valid card number')
      //   .required('Please enter your card number'),
      // creditCardExpiration: yup
      //   .string()
      //   .matches(/^(\d{2}\/\d{2}\/\d{4})$/, 'Please enter a valid expiry date')
      //   .required('Please enter your card expiry'),
      acceptTerms: yup
        .boolean()
        .oneOf([true], 'Please accept the Terms and Conditions to register.')
        .required('Please accept the Terms and Conditions to register.'),
      promoCode: yup.string(),
    })
    .required()

  const formSchema = {
    sections: [
      {
        id: 'promo',
        title: 'Promo code',
        description: false,
        isPromoSection: true,
        fieldKeys: ['promoCode'],
      },
      {
        id: 'rental',
        title: "Driver's license",
        description: false,
        isPromoSection: false,
        fieldKeys: ['licenseState', 'licenseNumber', 'licenseExpiration', 'acceptTerms'],
      },
      /* {
        id: 'creditCard',
        title: 'Credit card information',
        description: 'Your Blue Chip Membership is free. A credit card is required to be kept on file for future reservations. We request this information so on your first rental you can skip the airport counter and pick your car up directly at the lot.',
        isPromoSection: false,
        fieldKeys: [
          'creditCardType',
          'creditCardNumber',
          'creditCardExpiration',
        ]
      }, */
    ],
    fields: [
      {
        id: 'licenseState',
        label: "Driver's license issued in *",
        autocomplete: '',
        type: 'select',
        selectOptions: 'stateList',
        cssClass: '',
      },
      {
        id: 'licenseNumber',
        label: "Diver's license number",
        autocomplete: '',
        type: 'text',
        cssClass: '',
      },
      {
        id: 'licenseExpiration',
        label: 'License expiry [DD/MM/YYYY] *',
        autocomplete: '',
        type: 'date',
        cssClass: '',
      },
      {
        id: 'creditCardType',
        label: 'Credit card type *',
        autocomplete: '',
        type: 'select',
        selectOptions: 'cardTypes',
        cssClass: '',
      },
      {
        id: 'creditCardNumber',
        label: 'Card number',
        autocomplete: '',
        type: 'text',
        cssClass: '',
      },
      {
        id: 'creditCardExpiration',
        label: 'Card expiry [DD/MM/YYYY] *',
        autocomplete: '',
        type: 'date',
        cssClass: '',
      },
      {
        id: 'acceptTerms',
        htmlLabel: {
          __html:
            isPromoForm && promoTermsContiditionsLink != ''
              ? `I have read and agree to the Blue Chip <a href='/blue-chip-terms-and-conditions' target='_blank'>Terms and Conditions</a> and the <a href='${promoTermsContiditionsLink}' target='_blank'>Promotion Terms and Conditions</a>.`
              : "I have read and agree to the Blue Chip <a href='/blue-chip-terms-and-conditions' target='_blank'>Terms and Conditions</a>.",
        },
        autocomplete: '',
        type: 'checkbox',
        isTandC: true,
        description:
          'By selecting this checkbox you are indicating that you would like to periodically receive marketing and promotional materials via email from Thrifty. You can withdraw your consent to receive marketing and promotional materials at any time by using the unsubscribe link found in those electronic messages.',
        cssClass: 'fullWidth',
      },
    ],
  }

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: formData,
    resolver: yupResolver(validationSchema),
  })

  const onSubmit = data => {
    storeFormData(formIndex, data)
  }

  const goToPrevious = () => {
    changeTabs('prev', formIndex)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {formSchema.sections.map(section => {
        if (!section.isPromoSection || (isPromoForm && section.isPromoSection))
          return (
            <div className="formSection" key={`section-${section.id}`}>
              <h3>{section.title}</h3>

              {section.description && (
                <p className="fieldContainer fullWidth">{section.description}</p>
              )}

              {!section.isPromoSection &&
                section.fieldKeys.map(fieldKey => {
                  const props = formSchema.fields.filter(f => {
                    return f.id === fieldKey
                  })[0]
                  const Component = Fields[props.type] ?? 'unknown'

                  return (
                    <Component
                      key={fieldKey}
                      sectionId={section.id}
                      control={control}
                      register={register}
                      field={props}
                      isPromoForm={isPromoForm}
                      errors={errors}
                    />
                  )
                })}

              {section.isPromoSection && (
                <div className="fieldContainer" key="field-promoCode">
                  <input
                    {...register('promoCode')}
                    className={errors.promoCode ? 'error' : ''}
                    placeholder="Enter promo code"
                    defaultValue={formData.promoCode ?? ''}
                  />

                  {errors.promoCode && (
                    <div className="error-message">
                      <img src="/themes/thrifty/assets/images/form-error.svg" />
                      {errors.promoCode?.message}
                    </div>
                  )}
                </div>
              )}
            </div>
          )
      })}

      {formError.length > 0 && (
        <div style={{ fontSize: 14, color: 'red', marginBottom: 20 }}>
          <b>Something went wrong..</b>
          <ul>
            {formError.map((error, i) => {
              if (error.trim() === '') return null
              return <li key={i}>{error}</li>
            })}
          </ul>
        </div>
      )}

      <div className="formControls">
        <div className="button buttonPrevious" onClick={goToPrevious}>
          Back
        </div>
        <button className="button buttonSubmit" type="submit">
          Submit
        </button>
      </div>
    </form>
  )
}

export default FormPartThree
